/**
 * @GENERATED from Figma node 3638:51963
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ZipBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M9.238 16.613h2.77v1.847h2.762v2.853C14.745 23.17 13.888 24 12 24s-2.745-.83-2.77-2.687V18.46h.008zm3.275 5.385a.924.924 0 1 1-1.026-1.537.924.924 0 0 1 1.026 1.537"
      clipRule="evenodd"
    />
    <path
      fill="#7F776F"
      d="M12 14.774h2.77v1.846H12zM9.23 12.927H12v1.847H9.23zM12 11.08h2.77v1.847H12zM9.23 9.234H12v1.846H9.23zM12 7.387h2.77v1.847H12zM9.23 5.54H12v1.847H9.23zM12 3.693h2.77V5.54H12zM9.23 1.847H12v1.846H9.23zM12 0h2.77v1.847H12z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ZipBright);
export { ForwardRef as ZipBright };
